import { newId, type Sample, STANDARD_SAMPLE_TYPES, sampleTypeOptions } from '@quickreport/domain';
import { type LocalDb, queueChange, type Tx } from '@quickreport/sync';

/** Blood, Urine, Semen, then the lab's own, without repeats. */
export async function listSampleTypes(db: Pick<LocalDb, 'query'> | Tx): Promise<string[]> {
  const r = await db.query<{ name: string }>(
    'select distinct name from sample_types where deleted_at is null order by name',
  );
  return sampleTypeOptions(r.rows.map((x) => x.name));
}

/** Remember sample types that are not standard, so they are offered next time. */
export async function rememberSampleTypes(
  tx: Tx,
  orgId: string,
  samples: readonly Pick<Sample, 'type'>[],
): Promise<void> {
  const known = new Set<string>(STANDARD_SAMPLE_TYPES.map((s) => s.toLowerCase()));
  const have = await tx.query<{ name: string }>(
    'select name from sample_types where deleted_at is null',
  );
  for (const h of have.rows) known.add(h.name.trim().toLowerCase());
  for (const s of samples) {
    const name = s.type.trim();
    if (!name || known.has(name.toLowerCase())) continue;
    known.add(name.toLowerCase());
    const id = newId();
    await tx.query('insert into sample_types (id, org_id, name) values ($1, $2, $3)', [
      id,
      orgId,
      name,
    ]);
    await queueChange(tx, 'sample_types', id);
  }
}
